import React from "react";
import styled from "styled-components";
import mockup from "../../assets/bannerDash.png";

const Banner = () => {
  return (
    <Container>
      <div className="dot-background" />
      <div className="dot-mask" />
      <h3>WEB DESIGN & MARKETING AGENCY</h3>
      <h1>
        We <span>make</span> your <span>business</span>{" "}
        <br className="line-break" /> impossible <span>to </span>
        ignore.
      </h1>
      <h1></h1>
      <p>
        We build systems content and that finds your people, earns their trust,
        and turns them into buyers.
      </p>
      <div className="btns">
        <button>Our Work</button>
        <button>Contact Us</button>
      </div>
      <img src={mockup} alt="" />
      <iframe
        src="https://my.spline.design/worldplanet-nJ1hDpqviazrKDdUgoOm8vrV/"
        frameborder="0"
        width="100%"
        height="100%"
      ></iframe>
    </Container>
  );
};
const Container = styled.div`
  padding: 10em 7%;
  font-family: "Readex Pro", sans-serif;
  font-optical-sizing: auto;
  position: relative;
  background: radial-gradient(
    circle at 70% 23%,
    #33224d 0%,
    #120818 45%,
    #08040c 70%
  );
  z-index: -2;
  overflow: hidden;
  background-color: #08040c; /* Fallback */
  background-repeat: no-repeat;
  padding-bottom: 27em;

  iframe {
    position: absolute;
    top: 14%;
    left: 50%;
    transform: translateX(-0%);
    width: 100vw;
    height: 100%;
    object-fit: contain;
    opacity: 0.3;
    scale: 0.4;
  }

  h3 {
    text-align: center;
    color: #836caf;
    font-weight: 200;
    border: 1px solid #463d6e;
    display: flex;
    width: auto;
    justify-content: center;
    align-items: center;
    width: auto;
    max-width: min(400px, 92%);
    font-size: clamp(0.7rem, 2.6vw, 1rem);
    margin: auto;
    margin-top: 0%;
    padding: 5px;
    border-radius: 20px;
  }
  h1 {
    font-weight: 200;
    font-size: clamp(2.1rem, 6vw, 6.2rem);
    text-align: center;
    line-height: 1.08;
    span {
      color: #9281dd;
      font-weight: 300;
    }
  }
  p {
    text-align: center;
    color: #b6b6b6;
    margin-top: 1em;
    padding: 0 1em;
  }
  /* }
  .dot-background {
    position: absolute;
    inset: 0;
    background-size: 30px 30px;
    background-image: radial-gradient(#4d4081 1px, transparent 1px);
    z-index: -2;
  }

  .dot-mask {
    position: absolute;
    inset: 0;
    mask-image: radial-gradient(ellipse at center, transparent 20%, #e91414);
    -webkit-mask-image: radial-gradient(
      ellipse at center,
      transparent 20%,
      black
    );
    z-index: -2;
  } */
  .btns {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 7px;
    button {
      background: linear-gradient(to top, #201c2c, #30243c);
      color: white;
      border: none;
      font-size: 16px;
      border-radius: 25px;
      padding: 15px 25px;
      margin-top: 1em;
      font-weight: 300;
      border: 1px solid #30243c;
      font-family: "Montserrat";
    }
    :nth-child(2) {
      background: none;
      border: none;
      /* text-decoration: underline; */
      /* color: black; */
    }
  }
  img {
    margin: auto;
    display: flex;
    margin-top: 4%;
    width: 70%;
    opacity: 0.94;
    /* backdrop-filter: blur(10px); */
  }
  iframe {
    z-index: -1;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 00%;
    position: absolute;
    top: 14%;
    object-fit: contain;
    opacity: 0.3;
    scale: 2.4;
    margin: 0;
    padding: 0;
  }
  @media (max-width: 700px) {
    padding: 6em 5% 14em;
    h3 {
      margin-bottom: 1em;
      font-size: 14px;
    }
    img {
      width: 92%;
    }
  }
  @media (max-width: 500px) {
    iframe {
      transform: scale(0.4);
      opacity: 0.2;
    }
    h1 {
      .line-break {
        display: none;
      }
    }
    p {
      font-size: 13px;
      font-weight: 300;
    }
  }
`;

export default Banner;
